import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import UserList from '../components/UserList';
import UserDetails from '../components/UserDetails';
import { getUsers, updateUser, deleteUser } from '../services/api';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await getUsers();
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleUpdateUser = async (updatedData) => {
    try {
      await updateUser(selectedUser.id, updatedData);
      fetchUsers();
      setSelectedUser(null);
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  const handleDeleteUser = async (userId) => {
    try {
      await deleteUser(userId);
      fetchUsers();
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          User Management
        </Typography>
        <UserList
          users={users}
          onSelectUser={setSelectedUser}
          onDeleteUser={handleDeleteUser}
        />
        {selectedUser && (
          <Box sx={{ mt: 4 }}>
            <Typography variant="h5" gutterBottom>
              Edit User
            </Typography>
            <UserDetails user={selectedUser} onUpdate={handleUpdateUser} />
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setSelectedUser(null)}
              sx={{ mt: 2 }}
            >
              Cancel
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default UserManagement;